
const whoNoAvaibalePoliza = [
  'Flex', // Avoid Vida Flex
  'FLEX', // Avoid Vida Flex
  'Periodo', // Avoid Dotal - Sura
  'Simple New', // Avoid Dotal
  'Temp', // Avoid Temporal
  'Capital Constante', // Avoid Temporal
  'Inversión' // Avoid Vida Inversion
]

export default whoNoAvaibalePoliza



// WEBPACK FOOTER //
// ./src/interfaces/whoNoAvaibalePoliza.js